import { useState } from 'react';
import { CalendarArrowDown } from 'lucide-react';
import type { DailyReportScope } from '../../../../services/reportService';
import DailyReportModal from './DailyReportModal';

interface ScopedDailyReportButtonProps {
  /** Drill scope params for the current Explorer selection. */
  scope: DailyReportScope;
  /** Human-readable name of the current scope for the modal copy. */
  scopeLabel: string;
}

/**
 * Performance Explorer masthead button: downloads the day-specific engineers
 * report filtered to the CURRENT drill selection (India → state → location →
 * project). PDF only; date defaults to today. Distinct from the window-aggregate
 * "Download report" (ExportMenu) beside it, and from the portfolio-wide top-bar
 * "Download Daily Report".
 */
export default function ScopedDailyReportButton({ scope, scopeLabel }: ScopedDailyReportButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="flex items-center gap-1 rounded-lg border border-[rgba(11,59,46,0.24)] px-2 py-1.5 text-[10px] font-bold uppercase tracking-wide transition hover:bg-[rgba(11,59,46,0.05)]"
        style={{ color: '#1F5A47', backgroundColor: '#fcfaf3' }}
      >
        <CalendarArrowDown className="h-3 w-3" /> Daily report
      </button>
      <DailyReportModal
        open={open}
        onClose={() => setOpen(false)}
        title="Download Daily Report — this scope"
        description={`Covers engineers under ${scopeLabel} for the selected date, grouped by location → project → engineer.`}
        formats={['pdf']}
        scope={scope}
      />
    </>
  );
}
